var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgAddFriend = function SvgAddFriend(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 24"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#add-friend_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#FFF5B9",
    d: "M15.05 13.343a6.9 6.9 0 0 0-3.15-3.665 6.53 6.53 0 0 1-4.164 1.49 6.5 6.5 0 0 1-4.163-1.496C1.44 10.852 0 13.096 0 15.672v2.862c0 .655.54 1.187 1.208 1.187H9.15q-.008-.14-.006-.278c0-3.27 2.629-5.94 5.906-6.1M7.735 9.624c2.706 0 4.898-2.154 4.898-4.812S10.441 0 7.735 0 2.838 2.154 2.838 4.813 5.03 9.625 7.735 9.625"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#FFF5B9",
    d: "M15.36 14.882c-2.563 0-4.64 2.04-4.64 4.559 0 2.518 2.077 4.559 4.64 4.559S20 21.959 20 19.44c0-2.517-2.078-4.558-4.64-4.558"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#176F15",
    d: "M17.805 18.948h-1.988v-2.295h-.903v2.295h-1.987v1.043h1.987v2.295h.903v-2.295h1.988z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "add-friend_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h20v24H0z"
  })))));
};
export default SvgAddFriend;